import $ from "jquery"

// smooth animate link
$(function(){
  const $link = $('.js-link')

  $link.on('click', function(e) {
    e.preventDefault()

    const speed = 500
    const href = $(this).attr("href")
    const target = $(href == "#" || href == "" ? 'html' : href)
    const position = target.offset().top
    const headerHeight = $('#js-spMenu').outerHeight()
    const movePos = position - headerHeight

    $("html, body").animate({scrollTop:movePos}, speed, "swing")
    return false
  })
})

// switch tab
$(function() {
  const $tab = $('.js-tab'), $step = $('.js-step')

  $tab.on('click', function() {
    const index = $tab.index(this)

    $tab.removeClass('is-active')
    $(this).addClass('is-active')

    $step.removeClass('is-active')
    $step.eq(index).addClass('is-active')
  })
})
